module.exports = __webpack_public_path__ + "static/media/04-01.a99c7f0a.png";